import { ComponentClass } from 'react';
import Animate from './Animate';
import { AnimateProps } from './iAnimate';

export default Animate as ComponentClass<Partial<AnimateProps>>;
